/* rf-setup.js — Build Your Setup bundle-builder behavior (P3-2, builder-a).
   Drives sections/rf-setup-builder.liquid ([data-rf-setup] root).
   All prices/compare-at values come from Liquid-rendered data attributes
   (product/variant objects at render) — this file only sums them (FACTS rule:
   the savings chip is real compare_at deltas of the selected items, nothing else).
   Add-all POSTs ONE /cart/add.js items array, then opens UpCart via
   window.upcartOpenCart() with the same fallback chain as assets/rf-cart.js. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDec = parts.join('.');
    var noDec = Math.round(cents / 100)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (format && format.indexOf('{{') !== -1) {
      var out = format
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount\s*\}\}/g, withDec);
      /* unknown placeholder (e.g. amount_with_comma_separator) — don't render raw {{…}} */
      if (out.indexOf('{{') === -1) return out;
    }
    return '$' + withDec;
  }

  function init(root) {
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var showSavings = root.getAttribute('data-show-savings') !== 'false';
    var rows = root.querySelector('[data-rf-rows]');
    var emptyEl = root.querySelector('[data-rf-empty]');
    var thumbs = root.querySelector('[data-rf-thumbs]');
    var countEl = root.querySelector('[data-rf-count]');
    var totalEl = root.querySelector('[data-rf-total]');
    var wasEl = root.querySelector('[data-rf-bar-was]');
    var saveEl = root.querySelector('[data-rf-save]');
    var errEl = root.querySelector('[data-rf-err]');
    var addBtn = root.querySelector('[data-rf-add]');
    if (!addBtn) return;
    var ctaLabel = addBtn.getAttribute('data-label') || addBtn.textContent;
    var emptyText = addBtn.getAttribute('data-empty-text') || '';
    var isSubmitting = false;

    function fmt(cents) { return formatMoney(cents, moneyFormat); }

    function selectedInputs() {
      return Array.prototype.slice
        .call(root.querySelectorAll('[data-rf-item]'))
        .filter(function (i) { return i.checked && !i.disabled; });
    }

    function render() {
      var items = selectedInputs();
      var total = 0;
      var compareTotal = 0;
      var hasMachine = false;

      /* review rows */
      rows.textContent = '';
      items.forEach(function (input) {
        var price = parseInt(input.dataset.price, 10) || 0;
        var compare = parseInt(input.dataset.compare, 10) || 0;
        total += price;
        compareTotal += compare > price ? compare : price;
        if (input.dataset.kind === 'machine') hasMachine = true;

        var li = document.createElement('li');
        li.className = 'rf-sb__row';
        if (input.dataset.img) {
          var img = document.createElement('img');
          img.className = 'rf-sb__row-img';
          img.src = input.dataset.img;
          img.alt = '';
          img.loading = 'lazy';
          li.appendChild(img);
        }
        var title = document.createElement('span');
        title.className = 'rf-sb__row-title';
        title.textContent = input.dataset.title || '';
        if (input.dataset.vtitle) {
          var em = document.createElement('em');
          em.textContent = input.dataset.vtitle;
          title.appendChild(em);
        }
        li.appendChild(title);
        var priceEl = document.createElement('span');
        priceEl.className = 'rf-sb__row-price';
        priceEl.textContent = fmt(price);
        if (compare > price) {
          var s = document.createElement('s');
          s.textContent = fmt(compare);
          priceEl.appendChild(s);
        }
        li.appendChild(priceEl);
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'rf-sb__row-remove';
        rm.setAttribute('aria-label', 'Remove ' + (input.dataset.title || 'item'));
        rm.textContent = '✕'; /* ✕ — sanctioned text glyph */
        rm.addEventListener('click', function () {
          input.checked = false;
          render();
        });
        li.appendChild(rm);
        rows.appendChild(li);
      });

      if (emptyEl) emptyEl.hidden = items.length > 0;

      /* thumbnails (live bundle visual — PACK 3 cutouts via card_image chain) */
      if (thumbs) {
        thumbs.textContent = '';
        var shown = items.slice(0, 5);
        shown.forEach(function (input) {
          var li = document.createElement('li');
          if (input.dataset.img) {
            var img = document.createElement('img');
            img.src = input.dataset.img;
            img.alt = '';
            li.appendChild(img);
          } else {
            li.textContent = (input.dataset.title || '?').charAt(0);
          }
          thumbs.appendChild(li);
        });
        if (items.length > 5) {
          var more = document.createElement('li');
          more.textContent = '+' + (items.length - 5);
          thumbs.appendChild(more);
        }
      }

      /* count + totals */
      var n = items.length;
      if (countEl) {
        if (n === 0) countEl.textContent = emptyText;
        else if (hasMachine) countEl.textContent = n + (n === 1 ? ' item selected' : ' items selected');
        else countEl.textContent = n + (n === 1 ? ' extra selected' : ' extras selected') + ' · add your machine?';
      }
      if (totalEl) {
        totalEl.hidden = n === 0;
        totalEl.textContent = fmt(total);
      }
      var save = compareTotal - total;
      if (wasEl) {
        wasEl.hidden = !(n > 0 && save > 0);
        wasEl.textContent = save > 0 ? fmt(compareTotal) : '';
      }
      if (saveEl) {
        var showChip = showSavings && n > 0 && save > 0;
        saveEl.hidden = !showChip;
        saveEl.textContent = showChip ? 'You save ' + fmt(save) : '';
      }

      /* mid-flight render() (tile toggled while ADDING…) must not re-arm the CTA */
      addBtn.disabled = isSubmitting || n === 0;
      if (errEl && !isSubmitting) errEl.hidden = true;
    }

    /* selection changes */
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches && t.matches('[data-rf-item]')) {
        render();
        return;
      }
      if (t.matches && t.matches('[data-rf-variant-select]')) {
        var opt = t.selectedOptions[0];
        if (!opt) return;
        var tile = t.closest('[data-rf-tile]');
        var input = tile && tile.querySelector('[data-rf-item]');
        if (!input) return;
        input.dataset.vid = opt.value;
        input.dataset.price = opt.dataset.price || '0';
        input.dataset.compare = opt.dataset.compare || '0';
        input.dataset.vtitle = opt.dataset.vtitle || '';
        var priceDisplay = tile.querySelector('[data-rf-price-display]');
        var wasDisplay = tile.querySelector('[data-rf-was-display]');
        var p = parseInt(opt.dataset.price, 10) || 0;
        var c = parseInt(opt.dataset.compare, 10) || 0;
        if (priceDisplay) priceDisplay.textContent = fmt(p);
        if (wasDisplay) {
          wasDisplay.hidden = !(c > p);
          wasDisplay.textContent = c > p ? fmt(c) : '';
        }
        /* choosing an option implies intent — select the tile */
        if (!input.checked && !input.disabled) input.checked = true;
        render();
      }
    });

    /* one-click add-all: single /cart/add.js items array, UpCart-first opener
       (same fallback chain as assets/rf-cart.js) */
    addBtn.addEventListener('click', function () {
      var items = selectedInputs()
        .map(function (input) {
          return { id: parseInt(input.dataset.vid, 10), quantity: 1 };
        })
        .filter(function (item) { return item.id; });
      if (!items.length || addBtn.disabled || isSubmitting) return;
      isSubmitting = true;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      if (errEl) errEl.hidden = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          addBtn.textContent = 'Added';
          if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
          else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
          else {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          }
          setTimeout(function () {
            isSubmitting = false;
            addBtn.textContent = ctaLabel;
            addBtn.disabled = selectedInputs().length === 0;
          }, 2200);
        })
        .catch(function () {
          /* /cart/add.js is documented-partial, not atomic — a 422 can land a
             subset of the items. Reconcile against /cart.js: uncheck anything
             that actually made it in, so a retry can't double-add. */
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var inCart = {};
              (cart.items || []).forEach(function (li) { inCart[li.variant_id] = true; });
              selectedInputs().forEach(function (input) {
                if (inCart[parseInt(input.dataset.vid, 10)]) input.checked = false;
              });
            })
            .catch(function () { /* reconcile is best-effort */ })
            .then(function () {
              isSubmitting = false;
              addBtn.textContent = ctaLabel;
              addBtn.disabled = false;
              if (errEl) errEl.hidden = false;
              render();
              if (errEl) errEl.hidden = false; /* render() clears it when not submitting */
            });
        });
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-rf-setup]').forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
